import { render } from "./Mobile.vue?vue&type=template&id=8c290a18&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"

import "./Mobile.vue?vue&type=style&index=0&id=8c290a18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c290a18"

export default script